import React from "react";
import Marquee from "react-fast-marquee";

const words = [
  "Precision in every flight",
  "Heritage in every detail",
  "Excellence in aviation",
  "Kingdom Above the Clouds",
  "Discipline · Craft · Command",
];

export const EditorialMarquee = () => {
  return (
    <section
      className="relative border-y border-white/10 bg-[#050505] py-8 md:py-12 overflow-hidden"
      data-testid="editorial-marquee"
    >
      <Marquee gradient={false} speed={22} pauseOnHover={false}>
        {words.concat(words).map((w, i) => (
          <span
            key={i}
            className="font-serif-italic text-white/45 text-5xl md:text-7xl lg:text-8xl mx-10 md:mx-16 whitespace-nowrap"
          >
            {w}
            <span className="text-[#FF5A00] ml-10 md:ml-16">✦</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
};
